// extracted by mini-css-extract-plugin
export default {"Box":"roadmap-table-layout-module__Box__ZIl3X1q","Box_1":"roadmap-table-layout-module__Box_1__cH4OFJK"};